import Hosts from '../../../Hosts';

const object_type = '*'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/entidade_interna'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '', //ARMAZENO DO NOME COMERCIAL
        foto: [], //ARMAZENO DA FOTO
        rgpd: false,
        ativo: true,
        birthday: '',

        vat: '',
        iban: '',
        nbss: '',
        ass: '',   
        arquivo: '',     
        numero_contribuinte: '',
        validade_contribuinte: '',
        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },

        data_admissao: '',
        tipo_contrato: '',
        horas_semanais: '',
        seguro_acidente_trabalho: '',

        notify:[],
        observation: '',
        type: [],
        relacao: [],
        tag:'',
        imagem:'',
        cv: {},
        sexo: '',
        estado_civil: '',
        habilitacao_literaria: '',
    },

    addresses: [{
        village: '',
        city: '',
        entity: [],
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],

    contacts: [{
        name: '', //ARMAZENO DO NOME INSTITUCIONAL
        email: '',        
        principal: 'true',
        extensions: [],
        observation: '',
        phone:  '',
        mobile_phone: '',
        building_number: '',
        person_responsables: [{
            name: '',
            email: '',
            extensions: '',
            observation: '',
            phone: '',
            mobile_phone: ''
        }],
                
        departamento: [{ 
            id: '', 
            name: '', 
            software: []
        }],        
        
        /*
        departamentos: [           
           { id: 3, nome: 'Gestão' },
           { id: 4, nome: 'Informática' },
           { id: 5, nome: 'Jurídico' },
           { id: 6, nome: 'Logística' },
           { id: 7, nome: 'Multimédia' },
           { id: 8, nome: 'Pesquisa e Desenvolvimento' },
           { id: 9, nome: 'Produção' },
           { id: 10, nome: 'Recursos Humanos' },
           { id: 11, nome: 'Suporte ao Cliente' },
           { id: 12, nome: 'Tecnologias de Internet' }, 
        ],
        
        responsaveis: [
            { id: 1, name: 'Duarte Correia', email: 'duarte.correia332@outlook.com', mobile_phone: '962348291', resp: 'ASSEC', observation: '', departamentos: [1], },
            { id: 2, name: 'Joana Mendes', email: 'joanamendes@email.com', mobile_phone: '963450382', resp: 'ASSEC', observation: '', departamentos: [2, 4] },
            { id: 3, name: 'Mariana Pereira', email: 'marianapereira@email.com', mobile_phone: '964560473', resp: 'ASSEC', observation: '', departamentos: [3, 5] },
            { id: 4, name: 'Vitor Martins', email: 'vitormartins@email.com', mobile_phone: '965670584', resp: 'ASSEC', observation: '', departamentos: [4, 6] },
            { id: 5, name: 'Maria Domingues', email: 'mariadomingues@email.com', mobile_phone: '966780695', resp: 'ASSEC', observation: '', departamentos: [5, 7] },
            { id: 6, name: 'Tânia Matias', email: 'taniamatias@email.com', mobile_phone: '967890716', resp: 'ASSEC', observation: '', departamentos: [6, 8] },
            { id: 7, name: 'Júlio Salcedas', email: 'juliosalcedas@email.com', mobile_phone: '968900827', resp: 'ASSEC', observation: '', departamentos: [7, 9] },
            { id: 8, name: 'Ricardo Almeida', email: 'ricardoalmeida@email.com', mobile_phone: '969010938', resp: 'ASSEC', observation: '', departamentos: [8, 10] },
            { id: 9, name: 'Tiago Fernandes', email: 'tiagofernandes@email.com', mobile_phone: '960120049', resp: 'ASSEC', observation: '', departamentos: [9, 11] },
            { id: 10, name: 'Catarina Nunes', email: 'catarinanunes@email.com', mobile_phone: '961230150', resp: 'ASSEC', observation: '', departamentos: [10, 12] },
            { id: 11, name: 'Bruno Rodrigues', email: 'brunorodrigues@email.com', mobile_phone: '962340261', resp: 'ASSEC', observation: '', departamentos: [1, 11] },
            { id: 12, name: 'Sofia Oliveira', email: 'sofiaoliveira@email.com', mobile_phone: '963450372', resp: 'ASSEC', observation: '', departamentos: [1, 12] },
            { id: 13, name: 'David Fernandes', email: 'smokasmetin2@gmail.com', mobile_phone: '969348291', resp: 'ASSEC', observation: '', departamentos: [1, 2, 3, 6] }, 
        ],
        */      
    }],

    profile: { id: '', name: '' },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
